<template>
  <div
    :id="`conversationSummary-${conversationId}`"
    class="conversation-summary rounded p-3"
  ></div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "@/events/eventBus";

export default {
  name: "ConversationSummary",
  props: {
    conversationId: {
      type: String,
      required: true,
    },
    conversation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  created() {
    EventBus.$on("update-conversation-summary", (data) => {
      const { isNew, data: summary, conversationId } = data;
      if (conversationId === this.conversationId) {
        this.$emit("updated");
      }
    });
  },
  methods: {
  },
};
</script>

<style lang="scss">
.conversation-summary {
  width: 100%;
  min-height: 400px;
}
</style>
